export default function checkUndefined(e: any): e is undefined {
    return e === undefined || e === 'undefined';
}
